import axios from 'axios'

export default {
  name: 'Footer',
  components: {},
  data: {
    unsubscribeEmail: ''
  },
  methods: {
    showUnsubscribeModal () {
      this.$modal.show('unsubscribe')
    },
    hideUnsubscribeModal () {
      this.$modal.hide('unsubscribe')
    },
    unsubscribe () {
      axios({
        method: 'get',
        url: process.env.VUE_APP_API_URL + '?email=' + this.unsubscribeEmail + '&listId=2'
      }).then((response) => {
        console.log(response)
      })

      this.$router.push('/unsubscribe-successful')
    }
  }
}
